module.exports = __webpack_public_path__ + "static/media/foodprint_app8.62a8f3fa.jpg";